import React, { useEffect, useState, Fragment } from "react";
import Layout from "../Components/Reuseable/layout";
import Footer from "../Components/Reuseable/Footer.jsx";
import CoptRight from "../Components/Reuseable/Copyrights";
import Cookies from "js-cookie";
import { Accordion, Modal } from "react-bootstrap";
import "../../Webiste/Components/CSS/pagesCSS/dashboard.css";
import ScrollContainer from "react-indiana-drag-scroll";
import { useTranslation } from "react-i18next";
import { fetchsingleUser, STATUSES } from "../redux/getReducer/getSingleUser";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
// import "./ResultScreenNew.css"; // IMPORT NEW CSS
import Justsponsor from "./justsponser";
import { useNavigate } from "react-router-dom";
import VideoFrame from "../Components/Modal/VideoFrame";
import Lottie from 'lottie-react';
import Animate from "../assets/loader.json";
import { IoIosArrowDropdownCircle } from "react-icons/io";
import { IoMdPlay } from "react-icons/io";
import { BsCalendarDate } from "react-icons/bs";
import CalenderComponent from "../Components/Home/Components/Calendar";
import { fetchResultScreencreen } from "../redux/getReducer/getraceresultscreen";
import { fetchCalender } from "../redux/getReducer/getCalender";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import headerIcon from "../../Webiste/assets/data1/image 4.png";
import RecentActivitiesCard from "../Components/Home/Components/RecentActivitiesCard";
import LatestWinnersCard from "../Components/Home/Components/LatestWinnersCard";

// Import Assets
import horseIcon from "../assets/horse (2).png";
import weatherIcon from "../assets/weather-icon.jpeg";
import flagImg from "../assets/United Arab Emirates.png";

export default function ResultScreen() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");
  const { data: ResultScreencreen, status } = useSelector((state) => state.ResultScreencreen);

  const [isLoading, setIsLoading] = useState(false);
  const [showcalender, setshowcalender] = useState(false);
  const [userIsDesktop, setUserIsDesktop] = useState(true);
  const [show, setShow] = useState(false);
  const [modaldata, setmodaldata] = useState();
  const [myData, setmyData] = useState(new Date());
  const { data: CalenderData } = useSelector((state) => state.CalenderData);
  const [hasAutoSelected, setHasAutoSelected] = useState(false);

  useEffect(() => {
    window.innerWidth > 840 ? setUserIsDesktop(true) : setUserIsDesktop(false);
  }, []);

  const handleClose = () => setShow(false);
  const handleShow = async (data) => {
    setmodaldata(data);
    await setShow(true);
  };

  const getStatusBaseColor = (raceStatus) => {
    if (raceStatus === "Live") return "#ef3a45";
    if (raceStatus === "Due") return "#f37b21";
    if (raceStatus === "Completed" || raceStatus === "End") return "#ef3a45";
    if (raceStatus === "Cancelled") return "#4b4b4b";
    return "#ef3a45"; // Fallback color
  };

  const hexToRgba = (hex, opacity) => {
    if (!hex || !hex.startsWith("#")) return hex;
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  const startRef = React.useRef(moment().format("YYYY-MM-DD"));
  const start = startRef.current;

  useEffect(() => {
    dispatch(fetchResultScreencreen({ start }));
    dispatch(fetchCalender());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  // Auto-select best date logic
  useEffect(() => {
    if (CalenderData && CalenderData.length > 0 && !hasAutoSelected) {
      const today = moment().endOf('day');
      const raceDates = CalenderData.map(item => moment(item.start));

      const pastOrTodayRaces = raceDates.filter(d => d.isSameOrBefore(today));

      let targetDate = null;
      if (pastOrTodayRaces.length > 0) {
        targetDate = moment.max(pastOrTodayRaces).toDate();
      } else {
        targetDate = moment.min(raceDates).toDate();
      }

      if (targetDate && myData.toDateString() === new Date().toDateString()) {
        if (myData.toDateString() !== targetDate.toDateString()) {
          setmyData(targetDate);
          dispatch(fetchResultScreencreen({ start: moment(targetDate).format("YYYY-MM-DD") }));
        }
      }
      setHasAutoSelected(true);
    }
  }, [CalenderData, hasAutoSelected, myData, dispatch]);

  function handleRedirect(id) {
    const path = userIsDesktop ? `/race-detail?${id}` : `/racedetails?${id}`;
    navigate(path);
  }

  const getDateDataAccordingToTime = async (date) => {
    dispatch(fetchResultScreencreen({ start: date }));
    setmyData(date);
  };

  const numbers = `۰۱۲۳۴۵۶۷۸۹`;
  const convert = (num) => {
    let res = "";
    const str = num ? num.toString() : "";
    for (let c of str) { res += numbers.charAt(c); }
    return res;
  };

  return (
    <Fragment>
      {/* 1. Top Banner */}
      <div className="common-page-banner">
        <h1>{t("Result Overview")}</h1>
      </div>

      <div className="container-fluid new-main-wrapper">
        <div className="container">
          <div className="row new-layout-70-30">
            {/* LEFT COLUMN: RESULTS */}
            <div className="col-lg-9">
              <div className="new-white-card">
                <div className="new-card-title">
                  <h3>{t("RESULT")}</h3>
                  <img
                    src={headerIcon}
                    alt="logo"
                    style={{
                      width: "40px",
                      opacity: "0.3",
                      margin: "0 0 9px 0",
                    }}
                  />
                </div>

                <Accordion
                  defaultActiveKey="0"
                  flush
                  className="new-stats-accordion"
                >
                  {status === "loading" ? (
                    <Lottie
                      animationData={Animate}
                      style={{
                        width: "100px",
                        margin: "auto",
                        margin: "0 0 9px 0",
                      }}
                    />
                  ) : ResultScreencreen?.length !== 0 ? (
                    ResultScreencreen.map((singleracecourse, i) => (
                      <Accordion.Item
                        eventKey={String(i)}
                        key={i}
                        className="mb-3"
                        style={{ border: "none" }}
                      >
                        <Accordion.Header className="new-acc-header-wrapper">
                          <div
                            className="new-acc-header-btn"
                            dir={cookiedata === "ar" ? "rtl" : "ltr"}
                          >
                            <span
                              className="new-acc-header-accent"
                              style={{ backgroundColor: singleracecourse.ColorCodeData?.Color || "#4CAF50" }}
                            ></span>
                            <div className="new-acc-left-info">
                              <img
                                src={flagImg}
                                alt="flag"
                                style={{ width: "28px", height: "20px", objectFit: "cover", borderRadius: "3px", flexShrink: 0 }}
                              />
                              <span className="new-course-name">
                                {cookiedata === "en"
                                  ? singleracecourse.TrackNameEn
                                  : singleracecourse.TrackNameAr}
                              </span>
                              <span className="new-course-date">
                                {moment(myData).format("dddd, DD MMMM YYYY")}
                              </span>
                            </div>
                            <div className="new-acc-right-info">
                              <span className="new-race-stats">
                                {t("RACES")}{" "}
                                {singleracecourse.RaceCourseData.length}
                              </span>
                              <i
                                class="fa fa-chevron-down"
                                aria-hidden="true"
                              ></i>
                            </div>
                          </div>
                        </Accordion.Header>

                        <Accordion.Body style={{ padding: "15px 0" }}>
                          {/* MEETING DETAILS BAR (Top of Inner Content) */}
                          {/* <div className="new-meeting-details-bar">
                           
                            <div className="new-meeting-info-item">
                              <h2 className="main-meeting-title">
                                {t("Meeting Details")}
                              </h2>
                            </div>

                           
                            <div className="new-meeting-info-item">
                              <img
                                src={horseIcon}
                                alt="horse"
                                className="new-horse-icon"
                              />
                              <div className="info-content-box">
                                <b>{t("GOING")}</b>
                                <span>
                                  {singleracecourse.RaceCourseData[0] &&
                                    (cookiedata === "en"
                                      ? singleracecourse.RaceCourseData[0]
                                        .MeetingTypeData.NameEn
                                      : singleracecourse.RaceCourseData[0]
                                        .MeetingTypeData.NameAr)}
                                </span>
                              </div>
                            </div>

                         
                            <div className="new-meeting-info-item">
                              <img
                                src={weatherIcon}
                                alt="weather"
                                className="new-weather-icon"
                              />
                              <div className="info-content-box">
                                <b>{t("Weather Condition")}</b>
                                <span>
                                  {singleracecourse.RaceCourseData[0]
                                    ?.WeatherType || "Sunny"}
                                </span>
                              </div>
                            </div>
                          </div> */}
                          {/* RACE RESULT CARDS LOOP */}
                          <div className="custom-scrollbar " style={{ height: "1000px" }}>
                            {singleracecourse.RaceCourseData.map((data, idx) => (
                              <div
                                key={idx}
                                className="new-result-row-card"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleRedirect(data._id || data.id)}
                              >
                                {/* Left Blue Sidebar */}
                                <div className="new-row-sidebar">
                                  <div
                                    className="new-race-num-tag"
                                    style={{
                                      backgroundColor: getStatusBaseColor(data.RaceStatus),
                                      color: "#ffffff"
                                    }}
                                  >
                                    {t("Race")} {data.RaceNumber}
                                  </div>
                                  <div
                                    className="new-race-time-tag"
                                    style={{
                                      backgroundColor: hexToRgba(getStatusBaseColor(data.RaceStatus), 0.5),
                                      color: "#ffffff"
                                    }}
                                  >
                                    {moment(data.StartTime).format("hh:mm A")}
                                  </div>
                                  {data.RaceResultData[0] ? (
                                    <div
                                      className="new-see-result-link"
                                      style={{
                                        backgroundColor: hexToRgba(getStatusBaseColor(data.RaceStatus), 0.5),
                                        color: "#ffffff",
                                        borderTop: "1px solid rgba(255,255,255,0.2)"
                                      }}
                                      onClick={(e) => { e.stopPropagation(); handleRedirect(data._id || data.id); }}
                                    >
                                      {t("See Result")}
                                    </div>
                                  ) : null}
                                </div>

                                {/* Main Content Area */}
                                <div className="new-row-main-content">
                                  <div className="new-row-header">
                                    <h2 className="new-race-title">
                                      {t("Race")} {data.RaceNumber}
                                    </h2>
                                    {data.RaceResultData[0] && (
                                      <IoMdPlay
                                        className="new-play-btn"
                                        onClick={() =>
                                          handleShow(
                                            data.RaceResultData[0].VideoLink,
                                          )
                                        }
                                      />
                                    )}
                                  </div>

                                  {data.RaceResultData[0] ? (
                                    <div className="new-winners-grid">
                                      {/* Podium Section */}
                                      <div className="new-podium-section">
                                        <div className="new-podium-item">
                                          🏆 <b>{t("1st")}</b>{" "}
                                          {cookiedata === "en"
                                            ? data.RaceResultData[0].HorseIDData
                                              ?.NameEn
                                            : data.RaceResultData[0].HorseIDData
                                              ?.NameAr}
                                        </div>
                                        <div className="new-podium-item">
                                          🥈 <b>{t("2nd")}</b>{" "}
                                          {data.RaceResultData[1] &&
                                            (cookiedata === "en"
                                              ? data.RaceResultData[1].HorseIDData
                                                ?.NameEn
                                              : data.RaceResultData[1].HorseIDData
                                                ?.NameAr)}
                                        </div>
                                        <div className="new-podium-item">
                                          🥉 <b>{t("3rd")}</b>{" "}
                                          {data.RaceResultData[2] &&
                                            (cookiedata === "en"
                                              ? data.RaceResultData[2].HorseIDData
                                                ?.NameEn
                                              : data.RaceResultData[2].HorseIDData
                                                ?.NameAr)}
                                        </div>
                                      </div>

                                      <div className="new-vertical-divider"></div>

                                      {/* Details Grid */}
                                      <div className="new-details-section">
                                        <div className="new-detail-box">
                                          <b>{t("GOING")}</b>
                                          <span>
                                            {cookiedata === "en"
                                              ? data.MeetingTypeData?.NameEn
                                              : data.MeetingTypeData?.NameAr}
                                          </span>
                                        </div>
                                        <div className="new-detail-box">
                                          <b>{t("WINNING JOCKEY")}</b>
                                          <span
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              const id = data.RaceResultData[0].JockeyOnRaceDataResult?._id;
                                              if (id) navigate(`/jockey-detail?${id}`);
                                            }}
                                          >
                                            {cookiedata === "en"
                                              ? data.RaceResultData[0]
                                                .JockeyOnRaceDataResult?.NameEn
                                              : data.RaceResultData[0]
                                                .JockeyOnRaceDataResult?.NameAr}
                                          </span>
                                        </div>
                                        <div className="new-detail-box">
                                          <b>{t("PRIZE MONEY")}</b>
                                          <span>
                                            {t("AED")}{" "}
                                            {(data.FirstPrice +
                                              data.SecondPrice +
                                              data.ThirdPrice).toLocaleString()}
                                          </span>
                                        </div>
                                        <div className="new-detail-box">
                                          <b>{t("WINNING TRAINER")}</b>
                                          <span>
                                            {cookiedata === "en"
                                              ? data.RaceResultData[0]
                                                .TrainerOnRaceDataResult?.NameEn
                                              : data.RaceResultData[0]
                                                .TrainerOnRaceDataResult
                                                ?.NameAr}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div>
                                      <p className="text-muted small italic" style={{ marginBottom: "12px" }}>
                                        {t("No Result Announced Yet")}
                                      </p>
                                      <div className="new-details-section" style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
                                        <div className="new-detail-box">
                                          <b>{t("GOING")}</b>
                                          <span>
                                            {cookiedata === "en"
                                              ? data.MeetingTypeData?.NameEn || "-"
                                              : data.MeetingTypeData?.NameAr || "-"}
                                          </span>
                                        </div>
                                        <div className="new-detail-box">
                                          <b>{t("PRIZE MONEY")}</b>
                                          <span>
                                            {t("AED")}{" "}
                                            {((data.FirstPrice || 0) + (data.SecondPrice || 0) + (data.ThirdPrice || 0)).toLocaleString()}
                                          </span>
                                        </div>
                                        <div className="new-detail-box">
                                          <b>{t("DIST")}</b>
                                          <span>
                                            {data.TrackLengthData?.TrackLength || "-"}
                                          </span>
                                        </div>
                                        <div className="new-detail-box">
                                          <b>{t("Race Type")}</b>
                                          <span>
                                            {cookiedata === "en"
                                              ? data.RaceTypeModelData?.NameEn || "-"
                                              : data.RaceTypeModelData?.NameAr || "-"}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>

                        </Accordion.Body>
                      </Accordion.Item>
                    ))
                  ) : (
                    <Skeleton count={3} height={60} />
                  )}
                </Accordion>
              </div>
            </div>

            {/* RIGHT COLUMN: CALENDAR */}
            <div className="col-lg-3">
              <div className="new-sidebar-card">
                {/* <h3 className="new-updates-title" style={{marginBottom: '20px', fontWeight: '800'}}>{t("LATEST UPDATES")}</h3> */}
                <div className="new-calendar-card">
                  <CalenderComponent setmyData={setmyData} forcedDate={myData} />
                </div>
                <div style={{ marginTop: "20px" }}>
                  {/* <RecentActivitiesCard /> */}
                  <LatestWinnersCard />
                </div>
                <div style={{ marginTop: "30px" }}>{/* <Justsponsor /> */}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton className="popupheader"></Modal.Header>
        <Modal.Body>
          <VideoFrame data={modaldata} />
        </Modal.Body>
      </Modal>

      <Footer />
      <CoptRight />
    </Fragment>
  );
}
